import { useState } from 'react';
import { labApi } from '../../lib/api';
import type { LabProductImage } from './types';

const labels: Record<string, string> = { PRODUCT: 'Produkt', PACKAGING: 'Opakowanie', COMBO: 'Produkt z opakowaniem', BEFORE_AFTER: 'Typografia', PRODUCT_STYLE: 'Styl', current: 'Poprzednia grafika', operator: 'Załącznik operatora' };

function VerifiedReference({ src, label }: { src: string; label: string }) {
  const [failed, setFailed] = useState(false);
  return failed
    ? <p className="p-3 text-xs text-text-muted">Nie udało się potwierdzić tej wersji referencji. Odśwież widok; jeśli zdjęcie zostało zmienione lub usunięte, podgląd pozostanie niedostępny.</p>
    : <a href={src} target="_blank" rel="noreferrer"><img src={src} alt={label} loading="lazy" onError={() => setFailed(true)} className="h-28 w-full rounded-lg object-contain bg-white" /></a>;
}

export function ProductImageReferences({ productId, image }: { productId: string; image: LabProductImage }) {
  const manifest = image.metadata?.referenceManifest;
  return <details className="rounded-xl border border-border-subtle p-3 text-sm">
    <summary className="cursor-pointer font-medium text-text-secondary">Referencje użyte przy tym wyniku</summary>
    {!Array.isArray(manifest) ? <p className="mt-2 text-xs text-text-muted">Ten starszy wynik nie ma zapisanego potwierdzenia wersji załączników. Aktualne zdjęcia z biblioteki nie dowodzą, co wysłano podczas tej generacji.</p> : <>
      <p className="mt-2 text-xs text-text-muted">Podgląd pokazuje tylko plik zgodny z zapisem tej generacji. Załączników jednorazowych nie archiwizujemy.</p>
      <div className="mt-3 grid grid-cols-2 gap-3">
        {manifest.map((entry: unknown, index) => {
          if (!entry || typeof entry !== 'object') return null;
          const reference = entry as Record<string, unknown>;
          const label = labels[String(reference.role)] || 'Referencja';
          return <div key={`${index}-${String(reference.sha256)}`} className="space-y-1">
            <p className="text-xs font-medium text-text-secondary">{index + 1}. {label}</p>
            {typeof reference.sourceReferenceId === 'string'
              ? <VerifiedReference src={labApi.getProductImageReferenceUrl(productId, image.id, index, String(reference.sha256))} label={label} />
              : <p className="text-xs text-text-muted">Przesłano do generatora. Obraz nie jest archiwizowany w podglądzie.</p>}
          </div>;
        })}
      </div>
    </>}
  </details>;
}
